import i18n from "../../../../i18n.js";
import banner from "../../../../utility/assets/images/Slide-Image-1.jpg";
import hunting from "../../../../utility/assets/images/hunting.png";
import training from "../../../../utility/assets/images/training.png";
import shooting from "../../../../utility/assets/images/shooting.png";
import about_comp from "../../../../utility/assets/images/about_comp.jpg";
// 
import accessible from "../../../../utility/assets/images/accessible.png";
import custom from "../../../../utility/assets/images/custom.png";
import lowCost from "../../../../utility/assets/images/lowCost.png";

import logo_img1 from "../../../../utility/assets/images/logo_img1.png";
import logo_img2 from "../../../../utility/assets/images/logo_img2.png";
import logo_img3 from "../../../../utility/assets/images/logo_img3.png";
import logo_img4 from "../../../../utility/assets/images/logo_img4.png";
import logo_img5 from "../../../../utility/assets/images/logo_img5.png";
import logo_img6 from "../../../../utility/assets/images/logo_img6.png";
import our_service from "../../../../utility/assets/images/our_service.jpg";
import about_us_hero from "../../../../utility/assets/images/Slide-Image-4.jpg";
import team_ban from "../../../../utility/assets/images/Slide-Image-3.jpg";
import trans from "../../../../utility/assets/images/trans.png";
import gun from "../../../../utility/assets/images/gun.png";
import black_cote from "../../../../utility/assets/images/black_cote.jpg";
import thumb1 from "../../../../utility/assets/images/thumb1.png";
import thumb2 from "../../../../utility/assets/images/thumb2.png";
import blog1 from "../../../../utility/assets/images/blog1.jpg";
import blog2 from "../../../../utility/assets/images/blog2.jpg";
import blog3 from "../../../../utility/assets/images/blog3.jpg";
import ReactPlayer from "react-player";
import React, { useEffect, useRef } from "react";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { useState } from "react";
import ClientAddEdit from "../../../../utility/components/ClientAddEdit";
import axios from "axios";
import {
  loaderStateTrue,
  loaderStateFalse,
} from "../../../../actions/allActions";
import { connect } from "react-redux";
import Button from "../../../../utility/components/Button";
import { Link } from "react-router-dom";
import {
  P,
  HeaderOne,
  HeaderTwo,
  HeaderThree,
  HeaderFour,
  HeaderFive,
} from "../../../../utility/components/Typography";
import { withNamespaces } from "react-i18next";
import { fetchCmsBySlugs, getCmsLocalizedText } from "../../../../utility/services/cmsService";
import { isPublicNewsEnabled } from "../../../../utility/publicNewsFeature";
const baseURL = process.env.REACT_APP_BASE_URL;
const imageUrL = process.env.REACT_APP_IMAGE_URL;

const HOME_CMS_SLUGS = [
  "about-the-company-one",
  "about-the-company-two",
  "about-the-company-three",
  "what-we-provide-one",
  "what-we-provide-two",
  "what-we-provide-three",
  "what-we-provide-four",
  "what-we-provide-five",
  "what-trainees-say",
];

const Home = (props) => {
  const { userData, loaderStateTrue, loaderStateFalse, t } = props;
  const [logos, setLogos] = useState([]);
  const [videos, setVideos] = useState([]);
  const [bottomVideosPlaying, setBottomVideosPlaying] = useState(false);
  const bottomVideosSectionRef = useRef(null);
  const language = i18n.language;
  const [aboutCompanyOne, setAboutCompanyOne] = useState([]);
  const [aboutCompanyTwo, setAboutCompanyTwo] = useState([]);
  const [aboutCompanyThree, setAboutCompanyThree] = useState([]);
  const [weProvideOne, setWeProvideOne] = useState([]);
  const [weProvideTwo, setWeProvideTwo] = useState([]);
  const [weProvideThree, setWeProvideThree] = useState([]);
  const [weProvideFour, setWeProvideFour] = useState([]);
  const [weProvideFive, setWeProvideFive] = useState([]);
  const [traineeSay, setTraineeSay] = useState([]);
  const [testimonialData, setTestimonialData] = useState([]);
  useEffect(() => {
    getLogos();
    getVideos();
    fetchHomeCms();
    getTestimonial();
    if (isPublicNewsEnabled) {
      fetchData();
    }
  }, [language]);

  const fetchHomeCms = async () => {
    try {
      const cmsBySlug = await fetchCmsBySlugs(HOME_CMS_SLUGS);

      setAboutCompanyOne(getCmsLocalizedText(cmsBySlug["about-the-company-one"], language));
      setAboutCompanyTwo(getCmsLocalizedText(cmsBySlug["about-the-company-two"], language));
      setAboutCompanyThree(getCmsLocalizedText(cmsBySlug["about-the-company-three"], language));
      setWeProvideOne(getCmsLocalizedText(cmsBySlug["what-we-provide-one"], language));
      setWeProvideTwo(getCmsLocalizedText(cmsBySlug["what-we-provide-two"], language));
      setWeProvideThree(getCmsLocalizedText(cmsBySlug["what-we-provide-three"], language));
      setWeProvideFour(getCmsLocalizedText(cmsBySlug["what-we-provide-four"], language));
      setWeProvideFive(getCmsLocalizedText(cmsBySlug["what-we-provide-five"], language));
      setTraineeSay(getCmsLocalizedText(cmsBySlug["what-trainees-say"], language));
    } catch (error) {
      console.log(error);
    }
  };
  const getLogos = async () => {
    try {
      const response = await axios.get(`${baseURL}/logos`);
      setLogos(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const getVideos = async () => {
    try {
      const response = await axios.get(`${baseURL}/videos`);
      const videoUrls = response.data.data.map((video) => {
        // Check if the URL contains an iframe and extract the URL if so
        const iframeMatch = video.url.match(/src="([^"]+)"/);
        return iframeMatch ? iframeMatch[1] : video.url;
      });
      setVideos(videoUrls);
      return response;
    } catch (error) {
      console.log(error);
    }
  };
  const getTestimonial = async () => {
    try {
      const response = await axios.get(`${baseURL}/testimonials`);
      setTestimonialData(response.data.data);
      return response;
    } catch (error) {
      console.log(error);
    }
  };
  const sliderSettings = {
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2000,
  };

  const videoSettings = {
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    speed: 500,
    autoplaySpeed: 6000,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const testimonialSettings = {
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    dotsClass: "custom-dots",
    arrows: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 6000,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const ourNewsSettings = {
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    dotsClass: "custom-dots", // Add a custom class for the dots
    arrows: false,
    speed: 500,
    autoplaySpeed: 6000,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const smallLogoSettings = {
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    speed: 500,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const testimonials = [
    {
      name: "Jhone Dio",
      image: thumb1,
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      text2:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      name: "Jhone Dio",
      image: thumb2,
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      text2:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      name: "Jhone Dio",
      image: thumb2,
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      text2:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      name: "Jhone Dio",
      image: thumb2,
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      text2:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
  ];
  const [readMoreIndex, setReadMoreIndex] = useState(-1);
  const toggleReadMore = (index) => {
    if (readMoreIndex === index) {
      setReadMoreIndex(-1);
    } else {
      setReadMoreIndex(index);
    }
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const scrollToId = (id) => {
    const node = document.getElementById(id);
    if (node) {
      node.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  const [heroIndex, setHeroIndex] = useState(0);
  const [heroPaused, setHeroPaused] = useState(false);
  const [heroHoverIndex, setHeroHoverIndex] = useState(null);
  const [heroDragging, setHeroDragging] = useState(false);
  const heroDragStartXRef = useRef(null);
  const heroDragDeltaRef = useRef(0);
  const heroSlides = [
    {
      image: banner,
      kicker: t("homePageTitleKicker"),
      title: t("homePageTitle"),
      ctaLabel: t("homePageCtaDemo"),
      ctaType: "link",
      ctaTarget: "/contactUs",
    },
    {
      image: about_us_hero,
      kicker: t("homePageHeroSlide2Kicker"),
      title: t("homePageHeroSlide2Title"),
      ctaLabel: t("homePageHeroSlide2Cta"),
      ctaType: "scroll",
      ctaTarget: "home-problem",
    },
    {
      image: team_ban,
      kicker: t("homePageHeroSlide3Kicker"),
      title: t("homePageHeroSlide3Title"),
      ctaLabel: t("homePageHeroSlide3Cta"),
      ctaType: "scroll",
      ctaTarget: "home-provide",
    },
  ];
  useEffect(() => {
    const reduceMotion =
      typeof window !== "undefined" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion || heroPaused) {
      return undefined;
    }
    const timer = window.setInterval(() => {
      setHeroIndex((current) => (current + 1) % heroSlides.length);
    }, 6500);
    return () => window.clearInterval(timer);
  }, [heroPaused, language, heroSlides.length]);
  useEffect(() => {
    const section = bottomVideosSectionRef.current;
    if (!section || typeof IntersectionObserver === "undefined") {
      return undefined;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        setBottomVideosPlaying(entry.isIntersecting);
      },
      { threshold: 0.4 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);
  const displayedHeroIndex = heroHoverIndex !== null ? heroHoverIndex : heroIndex;
  const activeHeroSlide = heroSlides[displayedHeroIndex] || heroSlides[0];
  const handleHeroDragStart = (clientX) => {
    heroDragStartXRef.current = clientX;
    heroDragDeltaRef.current = 0;
    setHeroPaused(true);
    setHeroDragging(true);
  };
  const handleHeroDragMove = (clientX) => {
    if (heroDragStartXRef.current === null) {
      return;
    }
    heroDragDeltaRef.current = clientX - heroDragStartXRef.current;
  };
  const handleHeroDragEnd = () => {
    if (heroDragStartXRef.current === null) {
      return;
    }
    const delta = heroDragDeltaRef.current;
    const threshold = 60;
    if (delta <= -threshold) {
      setHeroIndex((current) => (current + 1) % heroSlides.length);
    } else if (delta >= threshold) {
      setHeroIndex((current) => (current - 1 + heroSlides.length) % heroSlides.length);
    }
    heroDragStartXRef.current = null;
    heroDragDeltaRef.current = 0;
    setHeroDragging(false);
    setHeroPaused(false);
  };
  const [blogData, setBlogData] = useState([]);
  const [pageNumber, setpageNumber] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [totalFetched, setTotalFetched] = useState(0);
  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/blogs?page=${pageNumber}&length=3`
      );
      setTotalCount(response.data.data.total);
      const newTotalFetched = totalFetched + response.data.data.blogs.length;
      setTotalFetched(newTotalFetched);
      if (pageNumber === 1) {
        // For initial fetch, set the response directly
        setBlogData(response.data.data.blogs);
      } else {
        // For subsequent fetches, append to the existing data
        setBlogData((prevData) => [...prevData, ...response.data.data.blogs]);
      }
      setpageNumber(pageNumber + 1);
    } catch (error) {
      console.log(error);
    }
  };

  const handleLoadMore = () => {
    fetchData();
  };
  return (
    <div className="home_page">
      <section className="banner_main home_banner">
        <div
          className={`banner_img home_hero_draggable${heroDragging ? " is-dragging" : ""}`}
          onMouseDown={(e) => handleHeroDragStart(e.clientX)}
          onMouseMove={(e) => handleHeroDragMove(e.clientX)}
          onMouseUp={handleHeroDragEnd}
          onMouseLeave={handleHeroDragEnd}
          onTouchStart={(e) => handleHeroDragStart(e.touches[0].clientX)}
          onTouchMove={(e) => handleHeroDragMove(e.touches[0].clientX)}
          onTouchEnd={handleHeroDragEnd}
        >
          <img
            key={displayedHeroIndex}
            src={activeHeroSlide.image}
            alt=""
            className="home_hero_bg_slide"
            draggable={false}
            onDragStart={(e) => e.preventDefault()}
          />
        </div>
        <div
          className="banner_txt home_hero_copy"
          onMouseEnter={() => setHeroPaused(true)}
          onMouseLeave={() => setHeroPaused(false)}
          onFocus={() => setHeroPaused(true)}
          onBlur={() => setHeroPaused(false)}
        >
          <div key={displayedHeroIndex} className="home_hero_slide">
            <p className="home_hero_kicker">{activeHeroSlide.kicker}</p>
            <h1 className="home_hero_title">{activeHeroSlide.title}</h1>
            {activeHeroSlide.ctaType === "link" ? (
              <Link className="home_hero_cta" to={activeHeroSlide.ctaTarget} onClick={scrollToTop}>
                {activeHeroSlide.ctaLabel}
              </Link>
            ) : (
              <button
                type="button"
                className="home_hero_cta"
                onClick={() => scrollToId(activeHeroSlide.ctaTarget)}
              >
                {activeHeroSlide.ctaLabel}
              </button>
            )}
          </div>
        </div>

        <nav className="home_hero_tabs" aria-label="Hero slides">
          <div className="container">
            <ul>
              {heroSlides.map((slide, index) => (
                <li key={slide.kicker}>
                  <button
                    type="button"
                    className={index === displayedHeroIndex ? "is-active" : ""}
                    onMouseEnter={() => {
                      setHeroPaused(true);
                      setHeroHoverIndex(index);
                    }}
                    onMouseLeave={() => {
                      setHeroPaused(false);
                      setHeroHoverIndex(null);
                    }}
                    onFocus={() => {
                      setHeroPaused(true);
                      setHeroHoverIndex(index);
                    }}
                    onBlur={() => {
                      setHeroPaused(false);
                      setHeroHoverIndex(null);
                    }}
                    onClick={() => {
                      setHeroIndex(index);
                      setHeroHoverIndex(null);
                    }}
                  >
                    {slide.kicker}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </nav>

        <nav className="home_hero_pills" aria-label="Hero slides">
          <ul>
            {heroSlides.map((slide, index) => (
              <li key={`pill-${slide.kicker}`}>
                <button
                  type="button"
                  className={index === displayedHeroIndex ? "is-active" : ""}
                  aria-label={slide.kicker}
                  aria-current={index === displayedHeroIndex ? "true" : undefined}
                  onClick={() => {
                    setHeroIndex(index);
                    setHeroHoverIndex(null);
                  }}
                />
              </li>
            ))}
          </ul>
        </nav>
      </section>

      <section className="service_sec home_adv_sec">
        <div className="container">
          <div className="service_list">
            <ul>
              <li>
                <button type="button" className="home_adv_link" onClick={() => scrollToId("home-provide")}>
                  <figure>
                    <img src={custom} alt="" />
                  </figure>
                  {t("homePageCustomizable")}
                </button>
              </li>
              <li>
                <button type="button" className="home_adv_link" onClick={() => scrollToId("home-problem")}>
                  <figure>
                    <img src={lowCost} alt="" />
                  </figure>
                  {t("homePageLowCost")}
                </button>
              </li>
              <li>
                <button type="button" className="home_adv_link" onClick={() => scrollToId("home-problem")}>
                  <figure>
                    <i className="fa-solid fa-brain" aria-hidden="true"></i>
                  </figure>
                  {t("homePageAiBased")}
                </button>
              </li>
              <li>
                <button type="button" className="home_adv_link" onClick={() => scrollToId("home-about")}>
                  <figure>
                    <img src={accessible} alt="" />
                  </figure>
                  {t("homePageAccessible")}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="home_ps_sec" id="home-problem">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <article className="home_ps_card">
                <h3>{t("homePageProblemTitle")}</h3>
                <P>{t("homePageProblemText")}</P>
              </article>
            </div>
            <div className="col-lg-6">
              <article className="home_ps_card home_ps_card--solution">
                <h3>{t("homePageSolutionTitle")}</h3>
                <P>{t("homePageSolutionText")}</P>
              </article>
            </div>
          </div>
        </div>
      </section>

      <section className="who_we_sec" id="home-about">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="who_we_txt">
                <div className="common_txt">
                  <span>{t("homePageWhoWeAre")}</span>
                  <HeaderTwo>{t("homePageAboutTheCompany")}</HeaderTwo>
                </div>
                <P>{t("homePageVision")}</P>
                <Link className="black_btn" to="/aboutUs" onClick={scrollToTop}>
                  {t("readMore")}
                </Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="who_we_img">
                <img src={about_comp} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="logo_sec">
        <div className="container">
          <div className="logo_innr">
            <div className="logo_slider">
              <Slider {...smallLogoSettings}>
                {logos.map((post, index) => {
                  return (
                    <div className="logo_slide_itm" key={index}>
                      <Link to="#">
                        <img src={`${imageUrL}/${post.image}`} alt="" />
                      </Link>
                    </div>
                  );
                })}
              </Slider>
            </div>
          </div>
        </div>
      </section>

      <section className="we_do_sec" id="home-provide">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="we_do_img">
                <figure>
                  <img src={our_service} alt="" />
                </figure>
                <div className="we_do_img_txt">
                  <P variant="large">{t("expertSafetyBanner")}</P>
                </div>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="we_do_txt">
                <div className="common_txt">
                  <span>{t("homePageOurServices")}</span>
                  <HeaderTwo>{t("whatWeProvide")}</HeaderTwo>
                </div>
                <div className="home_provide_list">
                  <article>
                    <span>01</span>
                    <h3>{t("homePageProvide1Title")}</h3>
                    <p>{t("homePageProvide1Text")}</p>
                  </article>
                  <article>
                    <span>02</span>
                    <h3>{t("homePageProvide2Title")}</h3>
                    <p>{t("homePageProvide2Text")}</p>
                  </article>
                  <article>
                    <span>03</span>
                    <h3>{t("homePageProvide3Title")}</h3>
                    <p>{t("homePageProvide3Text")}</p>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="video_slide_sec">
        <div className="video_slider">
          <Slider {...videoSettings}>
            {videos.map((videoUrl, index) => (
              <div key={index} className="video_slide_itm">
                <ReactPlayer url={videoUrl} controls width="100%" />
              </div>
            ))}
          </Slider>
        </div>
      </section>

      {/* client rec */}

      {/* <section className="testimonial_sec">
        <div className="gun_image">
          <img src={gun} alt="" />
        </div>
        <div className="back_ground_testimonial">
          <div className="left_background_testi"></div>
          <div className="right_background_testi">
            <img src={black_cote} alt="" />
          </div>
        </div>
        <div className="container">
          <div className="innter_testimonial">
            <div className="left_testimonial_part">
              <HeaderFour>{t("testimonial")}</HeaderFour>
              <HeaderTwo>{t("traineeSay")}</HeaderTwo>
              <P>{traineeSay}</P>
            </div>
            <div className="right_testimonial_part">
              <div className="testimonial_slider">
                <Slider {...testimonialSettings}>
                  {testimonialData.map((testimonial, index) => (
                    <div key={index} className="testimonial_box_outer">
                      <div className="testimonial_box">
                        <div className="testi_head">
                          <figure>
                            <img src={thumb1} alt="" />
                          </figure>
                          <HeaderFive>{testimonial.name}</HeaderFive>
                        </div>
                        <div
                          className="testimonial_content"
                          style={
                            readMoreIndex === index
                              ? { maxHeight: "120px", overflowY: "scroll" }
                              : {}
                          }
                        >
                          <P>
                            {readMoreIndex === index
                              ? testimonial.message
                              : testimonial.message
                                  .split(" ")
                                  .slice(0, 12)
                                  .join(" ") + "..."}
                          </P>
                        </div>
                        <Button
                          className="black_btn"
                          // href="javascript:void(0)"
                          onClick={() => toggleReadMore(index)}
                        >
                          {readMoreIndex === index ? "Read Less" : "Read More"}
                        </Button>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* client rec */}


      {/* <section className="blog_sec">
        <div className="container">
          <div className="common_txt text-center">
            <span>OUR recent blogs</span>
            <HeaderTwo>Our News</HeaderTwo>
          </div>
          <div className="blog_slider">
            <Slider {...ourNewsSettings} afterChange={handleLoadMore}>
              {blogData.length > 0
                ? blogData.map((post) => (
                    <Link to={`/newsDetails/${post.slug}`}>
                      <div className="blog_box_outer">
                        <div className="blog_box">
                          <figure>
                            <img src={`${imageUrL}/${post.image}`} alt="" />
                          </figure>
                          <HeaderTwo variant="small-plus">
                            <Link to="#">Lorem Ipsum is simply dummy text</Link>
                          </HeaderTwo>
                          <P>{post.description}</P>
                          <ul>
                            <li>
                              <Link to="#">April 25 2023</Link>
                            </li>
                            <li>
                              <Link to="#">5 Comments</Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </Link>
                  ))
                : null}
            </Slider>
          </div>
        </div>
        <div className="trans_receiver_image">
          <img src={trans} alt="" />
        </div>
      </section> */}

      <section className="home_two_videos_sec" ref={bottomVideosSectionRef}>
        <div className="container">
          <div className="home_two_videos_grid">
            <div className="home_video_item">
              <ReactPlayer
                url="https://www.youtube.com/watch?v=T6X52sVpD8U"
                playing={bottomVideosPlaying}
                muted
                controls
                width="100%"
                height="100%"
              />
            </div>
            <div className="home_video_item">
              <ReactPlayer
                url="https://www.youtube.com/watch?v=VnXvIx-H2kM"
                playing={bottomVideosPlaying}
                muted
                controls
                width="100%"
                height="100%"
              />
            </div>
          </div>
        </div>
      </section>

      <style>
        {`
          /* Custom dots styling */
          .custom-dots {
              display: flex !important;
              justify-content: center;
              margin-top: 20px; /* Adjust margin as needed */
          }

          .custom-dots button {
              background: white;
              border: none;
              cursor: pointer;
              margin-right: 5px !important;
              font-size: 0
          }

          .custom-dots span {
              width: 30px; /* Adjust width as needed */
              height: 2px;
              background-color: white;
          }
        `}
      </style>
    </div>
  );
};

const mapStateToProps = (globalState) => {
  return { userData: globalState.mainReducerData.userData };
};
// export default Home;
export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse })(
  withNamespaces()(Home)
);
